import {
  Card,
  CardContent,
  Typography,
  Tooltip,
  Box,
  IconButton,
} from "@mui/material";
import {
  Message as MessageIcon,
  Reply as ReplyIcon,
  CallReceived as IncomingIcon,
  DragHandle as DragHandleIcon,
  InfoOutlined as InfoIcon,
} from "@mui/icons-material";
import PlayCircleFilledWhiteIcon from "@mui/icons-material/PlayCircleFilledWhite";

const iconMap = {
  message: <MessageIcon fontSize="small" />,
  starter: <PlayCircleFilledWhiteIcon fontSize="small" />,
};

const typeDescriptions = {
  message: "Message builder. Build your customized message with this node.",
  starter: "This is where the flow will start. Incoming or reply button.",
};

const PaletteCard = ({ label, type }) => (
  <Tooltip
    title={`Drag and drop this ${label} onto the canvas to add it to your flow`}
    placement="right"
    arrow
  >
    <Card
      draggable
      onDragStart={(e) => {
        e.dataTransfer.setData("application/reactflow", type);
        e.dataTransfer.effectAllowed = "move";
      }}
      sx={{
        mb: 2,
        cursor: "grab",
        borderLeft: "4px solid",
        borderColor: "primary.main",
        transition: "transform 0.2s, box-shadow 0.2s",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: 3,
        },
      }}
    >
      <CardContent sx={{ p: 1.5 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {iconMap[type]}
            <Typography variant="body2" fontWeight="medium">
              {label}
            </Typography>
          </Box>
          <DragHandleIcon fontSize="small" color="action" />
        </Box>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ mt: 0.5, display: "block" }}
        >
          {typeDescriptions[type]}
        </Typography>
      </CardContent>
    </Card>
  </Tooltip>
);

export default PaletteCard;
